import React from 'react'
import { PriceTag, Product, ProductTileInfo, Title } from 'src/components/ProductGrid/styles'
import { getPriceWithSale } from 'src/utils/price'
import StoreContext from 'src/context/StoreContext'
import {
  ProductImg,
  ProductImagePlaceHolder,
  SoldOutOverlay,
  StLink,
  ProductImgContainer,
  ProductImgContainerFadeIn,
} from './styles'
import { getTagForProduct } from 'src/utils/product'
import get from 'lodash/get'

export const ProductTileSingleColumn = ({ product, fadeInImage }) => {
  const { checkout } = React.useContext(StoreContext)

  const {
    id,
    title,
    handle,
    media: [firstImage],
    variants,
    metafields,
  } = product

  const productTitle = get(
    metafields.find(field => field.key === 'articelname'),
    'value',
    [title]
  )

  const anyVariantAvailableForSale = variants.some(variant => variant.inventoryQuantity > 0)

  const isPreOrder = get(
    product.metafields.find(field => field.key === 'isPreOrder'),
    'value'
  )

  const isNotSoldOut = get(
    product.metafields.find(field => field.key === 'isNotSoldOut'),
    'value'
  )

  const isProductNotReallySoldOut = () => {
    return isNotSoldOut === '1' || isNotSoldOut === 'true'
  }

  const productTag = getTagForProduct(
    product.variants,
    product.variants.availableForSale,
    product.createdAt,
    false,
    isPreOrder,
    isNotSoldOut,
    product.id
  )

  return (
    <Product key={id}>
      <StLink to={`/product/${handle}/`}>
        {anyVariantAvailableForSale || isProductNotReallySoldOut() ? null : <SoldOutOverlay />}
        {productTag}
        {firstImage && firstImage.image.gatsbyImageData ? (
          <>
            <ProductImgContainer showTransition={!!fadeInImage}>
              <ProductImg image={firstImage.image.gatsbyImageData} alt={handle} />
            </ProductImgContainer>
            {fadeInImage && fadeInImage.image.gatsbyImageData ? (
              <ProductImgContainerFadeIn>
                <ProductImg image={fadeInImage.image.gatsbyImageData} alt={handle} />
              </ProductImgContainerFadeIn>
            ) : null}
          </>
        ) : (
          <ProductImgContainer>
            <ProductImagePlaceHolder />
          </ProductImgContainer>
        )}
      </StLink>
      <ProductTileInfo>
        <Title>{productTitle}</Title>
        <PriceTag>{getPriceWithSale(variants, checkout)}</PriceTag>
      </ProductTileInfo>
    </Product>
  )
}
